import NoConsentWidget from '@components/components/NoConsentWidget/NoConsentWidget';
import styles from '@components/components/CmsComponents/components/CmsYouTube/CmsYouTube.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { CheckConsent } from '@wienenergiegithub/modules-next/components';
import classNames from 'classnames';

const getFullVideoUrl = (
  videoId,
  autoplay,
  enhancedPrivacy,
  suggestions,
  controls,
  showInfo,
) => {
  const params = [];

  if (enhancedPrivacy) {
    params.push('https://www.youtube-nocookie.com/embed/');
  } else {
    params.push('https://www.youtube.com/embed/');
  }

  params.push(videoId);
  params.push(autoplay ? '?autoplay=1' : '?autoplay=0');

  if (!suggestions) {
    params.push('&rel=0');
  }

  if (!controls) {
    params.push('&controls=0');
  }

  if (!showInfo) {
    params.push('&showinfo=0');
  }

  return params.join('');
};

const CmsYouTube = ({
  autoplay,
  controls,
  disableLazyLoading,
  enhancedPrivacy,
  showInfo,
  size,
  suggestions,
  title,
  url,
}) => {
  const [, videoId] = url.split('?v=')[1] ? url.split('?v=') : url.split('be/');
  const videoUrl = getFullVideoUrl(
    videoId,
    autoplay,
    enhancedPrivacy,
    suggestions,
    controls,
    showInfo,
  );

  return (
    <div className={classNames(styles.container, styles[size])}>
      <CheckConsent noConsent={NoConsentWidget} services={['yt']}>
        {/* While combining allow-scripts & allow-same-origin is strongly
        discouraged, it's also necessary for YouTube videos to function. Since
        this component is exclusively used for YouTube videos, which we
        consider a trusted source, the exception remains.
        See: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#sect6 */}
        {/* eslint-disable-next-line react/iframe-missing-sandbox */}
        <iframe
          allowFullScreen
          className={styles.video}
          loading={disableLazyLoading ? 'eager' : 'lazy'}
          sandbox="allow-scripts allow-same-origin"
          src={videoUrl}
          title={title}
        />
      </CheckConsent>
    </div>
  );
};

CmsYouTube.propTypes = {
  autoplay: PropTypes.bool,
  controls: PropTypes.bool,
  disableLazyLoading: PropTypes.bool,
  enhancedPrivacy: PropTypes.bool,
  showInfo: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'largest', 'full']),
  suggestions: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
};

CmsYouTube.defaultProps = {
  autoplay: false,
  controls: true,
  disableLazyLoading: false,
  enhancedPrivacy: true,
  showInfo: true,
  size: 'small',
  suggestions: true,
  title: 'YouTube Video',
};

export default CmsYouTube;
